import React, { useEffect } from 'react'
import { HashRouter, Route, Routes, BrowserRouter as Router, } from 'react-router-dom'
import './scss/style.scss'
import PrivateRoute from './views/PrivateRoute'
import { useTranslation } from 'react-i18next'
import { ToastContainer } from 'react-toastify'
import './components/style.scss'
import { initialAxiosInstance, initialUseTranslation } from './service/apiCall'
// import Register from './views/pages/auth/authForm/Register'
// import Login from './views/pages/auth/authForm/Login'
import GetVerificationCode from './views/pages/auth/authForm/GetVerificationCode'
import PackageView from './views/pages/packageView'
import Pay from './views/pages/Invoice/Pay'
// import Payment from './views/pages/Invoice/Pay/payment'


import Login from './views/pages/auth/login'
import VCodeLogin from './views/pages/auth/login/loginWithVCode'
import Instance from './views/pages/auth/login/instance'
import Register from './views/pages/auth/register'
import TenantMemberRegistration from './views/pages/auth/TenantMemberRegisteration'
import ChangePassword from './views/pages/auth/changePassword'
import SetPassword from './views/pages/auth/changePassword/setPassWord'
import PayBackDetection from './components/payBackDetection'
import { useDispatch, useSelector } from 'react-redux'
import { setUserInfo } from './service/actions/userActions'
import { detectionPrivateRoute, shortLinkDetection } from './components/helper'
import ShortLink from './components/ShortLink'
import { DataProvider } from './components/dataContextChat'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const Profile = React.lazy(() => import('./views/pages/profile'))
// Pages
// const Login = React.lazy(() => import('./views/pages/auth/authForm/Login'))
// const Register = React.lazy(() => import('./views/pages/auth/authForm/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
// const AddMember = React.lazy(() => import('./views/pages/wizard/addMember'))
// const SetDomain = React.lazy(() => import('./views/pages/wizard/setDomain'))
// const ScriptCode = React.lazy(() => import('./views/pages/wizard/scriptCode'))
// const GetVerificationCode = React.lazy(() => import('./views/pages/auth/authForm/GetVerificationCode'))
// const PackageView = React.lazy(() => import('./views/pages/packageView'))
const PolicyPrivacy = React.lazy(() => import('./views/pages/PolicyPrivacy'))
const Utilities = React.lazy(() => import('./views/pages/Utilities'))
const GetPassword = React.lazy(() => import('./views/pages/auth/authForm/GetPasswordForm'));


const App = () => {
  const { i18n, t } = useTranslation()
  const dispatch = useDispatch()
  const signedInUser = useSelector(state => state.userReducer.signedInUser)

  initialUseTranslation(t)
  // global.roles = Roles;

  useEffect(() => {
    document.body.dir = i18n.dir()
    document.getElementsByTagName('html')[0].setAttribute("dir", i18n.dir())
    document.documentElement.setAttribute('lang', i18n.language)
    document.getElementsByTagName('body')[0].classList.remove('fa')
    document.getElementsByTagName('body')[0].classList.remove('en')
    document.getElementsByTagName('body')[0].classList.add(i18n.language)
  }, [i18n.language])

  useEffect(() => {
    shortLinkDetection();
    const multiTenants = localStorage.getItem("multiTenants")
    const accessToken = localStorage.getItem('accessToken')
    const userMenu = localStorage.getItem('userMenu')
    const sipOnlineUser = localStorage.getItem('sipOnlineUser')
    // console.log(window.location)
     
    if (sipOnlineUser) {
      initialAxiosInstance(accessToken, i18n.language, JSON.parse(sipOnlineUser).tenants[0].tenantId)
      dispatch(setUserInfo({
        sipOnlineUser: JSON.parse(sipOnlineUser),
        userMenu: JSON.parse(userMenu),
        accessToken: accessToken,
        multiTenants: multiTenants ? JSON.parse(multiTenants) : null
      }))
    } else {
      detectionPrivateRoute()
    }
  }, [])


  return (
    <>

      <Router>
        <Routes>
          <Route exact path="/login" name="Login Page" element={<Login />} />

            <Route exact path="/shortLink/:key" name="short Link" element={<ShortLink />} />

          <Route exact path="/tmr/:email/:id/:token" name="tenantMemberRegister" element={<TenantMemberRegistration />} />
            <Route exact path="/vcodeLogin" name="Login Page" element={<VCodeLogin />} />
            <Route exact path="/loginInstances" name="Login Page" element={<Instance />} />

            {/* <Route exact path="/login/:packageId/:durationId" name="Login Page" element={<LoginWizard />} /> */}
            <Route exact path="/signup/:step" name="Signup page" element={<Register />} />
            <Route exact path="/signupWizard/:step/:invoiceId" name="Signup payback" element={<Register />} />



            <Route exact path="/signup/:step/:packageId/:durationId" name="Signup page" element={<Register />} />

            <Route exact path="/pay/:id/:type" name="pay Page" element={<Pay />} />
            <Route exact path="/pay/:id" name="pay Page" element={<Pay />} />
            {/* <Route exact path="/payment/:id" name="pay Page" element={<Payment />} /> */}

            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route exact path="/getVerificationCode" name="getVerificationCode" element={<GetVerificationCode />} />
            <Route exact path="/getPassword" name="getPassword" element={<GetPassword />} />
            <Route exact path="/packages" name="packages" element={<PackageView />} />
            <Route exact path="/policy&privacy" name="policy&privacy" element={<PolicyPrivacy />} />
            <Route exact path="/recoveryPassword" name="policy&privacy" element={<ChangePassword />} />
            <Route exact path="/ResetPassword/:email" name="policy&privacy" element={<SetPassword />} />


            <Route exact path="/bankBack/:id" name="PayBackDetection" element={<PayBackDetection />} />
            <Route exact path="//utilities" name="PayBackDetection" element={<Utilities />} />

            {signedInUser &&
              <Route path="*" element={<PrivateRoute />}>
                <Route path="*" name="Home" element={<DefaultLayout />} />
              </Route>}
          </Routes>
      </Router>
      <ToastContainer
        position={i18n.language === "fa" ? "top-right" : "top-left"}
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={i18n.language === 'fa'}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

    </>

  )
}

export default App
